"use strict";

function CustomAccordion() {
  var items = document.querySelectorAll('.js-accordion-item');
  items.forEach(function (item) {
    if (item.dataset.accordionInit === 'true') return;
    item.dataset.accordionInit = 'true';
    var header = item.querySelector('.accordion-item__header');
    var content = item.querySelector('.accordion-item__content');
    if (!header || !content) return;
    function open(activeItem) {
      var activeContent = activeItem.querySelector('.accordion-item__content');
      activeItem.classList.add('is-open');
      if (activeContent) {
        activeContent.style.maxHeight = "".concat(activeContent.scrollHeight, "px");
      }
    }
    function close(activeItem) {
      var activeContent = activeItem.querySelector('.accordion-item__content');
      activeItem.classList.remove('is-open');
      if (activeContent) {
        activeContent.style.maxHeight = '0px';
      }
    }
    close(item);
    header.addEventListener('click', function () {
      if (item.classList.contains('is-open')) {
        close(item);
      } else {
        open(item);
      }
    });
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.js-accordion-item.is-open').forEach(function (item) {
      var content = item.querySelector('.accordion-item__content');
      if (content) {
        content.style.maxHeight = "".concat(content.scrollHeight, "px");
      }
    });
  });
}
CustomAccordion();